/**
 * Хранилище access-токена кабинета.
 *
 * РЕШЕНИЕ: токен не хранится нигде, кроме переменной этого модуля. То есть — в памяти
 * одной вкладки, и живёт он ровно до её закрытия или обновления.
 *
 * ПОЧЕМУ НЕ localStorage. localStorage общий для всего источника: его читает любой скрипт
 * на странице и любая вкладка того же салона. Одна XSS-дыра в стороннем виджете уносит
 * оттуда доступ ко всей базе клиентов, и уносит надолго — токен там переживает и закрытие
 * браузера. Это же записано в ADR-024 и прямо в комментарии к контракту CabinetTokenPair.
 *
 * ПОЧЕМУ НЕ sessionStorage. Он не общий между вкладками, но всё так же читается скриптом
 * и всё так же попадает на диск профиля. От XSS он не защищает вовсе — а именно от неё
 * здесь и защищаются: сервер уже ограничил время жизни токена пятнадцатью минутами.
 *
 * ПОЧЕМУ НЕ ЛОМАЕТСЯ ОБНОВЛЕНИЕ СТРАНИЦЫ. Переживать F5 обязан не токен, а СЕССИЯ, и она
 * переживает: refresh лежит в httpOnly-cookie `plnr_cabinet_rt` (Path=/v1/cabinet/auth,
 * SameSite=Strict, Secure), которую скрипт не прочитает ни в одной вкладке. При старте
 * кабинет один раз молча зовёт POST /v1/cabinet/auth/refresh, получает новый access-токен
 * и кладёт его сюда. Человек видит каркас загрузки, а не форму входа.
 *
 * ПОЧЕМУ ТОКЕН НЕ «УТЕКАЕТ В ЧУЖИЕ ВКЛАДКИ». Переменная модуля принадлежит своему
 * JavaScript-контексту: у соседней вкладки он свой. Ни BroadcastChannel, ни storage-события
 * здесь не используются намеренно — общий канал между вкладками и есть тот самый способ
 * раздать токен всем, кто слушает.
 */

interface StoredToken {
  readonly value: string
  /** Момент истечения в миллисекундах эпохи — с ним дешевле сравнивать, чем со строкой. */
  readonly expiresAtMs: number
}

let stored: StoredToken | null = null

/**
 * Запас перед истечением. Токен, которому осталось меньше, считается протухшим:
 * иначе запрос, отправленный за секунду до конца срока, доедет до сервера уже мёртвым
 * и человек получит отказ там, где мог бы получить данные.
 */
const EXPIRY_SKEW_MS = 30_000

export const accessTokenStore = {
  /** Токен для заголовка Authorization или null, если его нет или он уже протух. */
  read(): string | null {
    if (stored === null) return null
    if (stored.expiresAtMs - EXPIRY_SKEW_MS <= Date.now()) return null
    return stored.value
  },

  /** Есть ли вообще токен — даже протухший. Отличать нужно: протухший чинится обновлением. */
  isEmpty(): boolean {
    return stored === null
  },

  write(value: string, expiresAt: string): void {
    const parsed = Date.parse(expiresAt)
    stored = {
      value,
      // Если сервер вернул момент, который мы не разобрали, лучше считать токен
      // короткоживущим и обновиться лишний раз, чем ходить с ним вечно.
      expiresAtMs: Number.isNaN(parsed) ? Date.now() : parsed,
    }
  },

  clear(): void {
    stored = null
  },
}
